/**
 * Auth zod schemas — REQ-20260417003.
 * 前後端共用：前端 react-hook-form 用、後端 ZodValidationPipe 用。
 */
import { z } from 'zod';
import { Role } from '../enums/role';

export const LoginSchema = z.object({
  email: z.string().trim().email(),
  password: z.string().min(1).max(200),
  remember: z.boolean().optional().default(false),
});
export type LoginInput = z.infer<typeof LoginSchema>;

export const ChangePasswordSchema = z.object({
  oldPassword: z.string().min(1).max(200),
  newPassword: z
    .string()
    .min(8, '密碼至少 8 字元')
    .max(200, '密碼最長 200 字元'),
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordSchema>;

/** 登入後回給前端的 user envelope（passwordHash / deletedAt 絕不外露）。 */
export const AuthUserSchema = z.object({
  id: z.number().int().positive(),
  username: z.string(),
  displayName: z.string(),
  email: z.string(),
  role: z.nativeEnum(Role),
  isActive: z.boolean(),
});
export type AuthUser = z.infer<typeof AuthUserSchema>;

export const LoginResponseSchema = z.object({
  user: AuthUserSchema,
  accessToken: z.string(),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
